'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import type { Booking } from './BookingTableRow';

interface ExportButtonProps {
  bookings: Booking[];
}

const ExportButton = ({ bookings }: ExportButtonProps) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = () => {
    setIsExporting(true);

    const headers = [
      'Booking ID',
      'Customer Name',
      'Email',
      'Phone',
      'Service',
      'Date',
      'Time',
      'Status',
      'Notes',
      'Created At',
    ];

    const csvData = bookings.map((booking) => [
      booking.id,
      booking.customerName,
      booking.customerEmail,
      booking.customerPhone,
      booking.service,
      booking.date,
      booking.time,
      booking.status,
      booking.notes || '',
      booking.createdAt,
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map((row) => row.map((cell) => `"${cell}"`).join(',')),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `bookings_export_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      setIsExporting(false);
    }, 1000);
  };

  return (
    <button data-component-id="src/app/all-bookings-view/components/ExportButton.tsx:66:4" data-component-path="src/app/all-bookings-view/components/ExportButton.tsx" data-component-line="66" data-component-end-line="78" data-component-file="ExportButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-4%20py-2%20bg-secondary%20text-secondary-foreground%20rounded-lg%20font-caption%20font-medium%20hover%3Abg-secondary%2F90%20transition-smooth%20focus-ring%20flex%20items-center%20gap-2%20disabled%3Aopacity-50%20disabled%3Acursor-not-allowed%22%7D"
      onClick={handleExport}
      disabled={isExporting || bookings.length === 0}
      className="px-4 py-2 bg-secondary text-secondary-foreground rounded-lg font-caption font-medium hover:bg-secondary/90 transition-smooth focus-ring flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <Icon data-component-id="src/app/all-bookings-view/components/ExportButton.tsx:71:6" data-component-path="src/app/all-bookings-view/components/ExportButton.tsx" data-component-line="71" data-component-end-line="75" data-component-file="ExportButton.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
        name={isExporting ? 'ArrowPathIcon' : 'ArrowDownTrayIcon'}
        size={18}
        className={isExporting ? 'animate-spin' : ''}
      />
      <span data-component-id="src/app/all-bookings-view/components/ExportButton.tsx:76:6" data-component-path="src/app/all-bookings-view/components/ExportButton.tsx" data-component-line="76" data-component-end-line="76" data-component-file="ExportButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22hidden%20sm%3Ainline%22%7D" className="hidden sm:inline">{isExporting ? 'Exporting...' : 'Export CSV'}</span>
      <span data-component-id="src/app/all-bookings-view/components/ExportButton.tsx:77:6" data-component-path="src/app/all-bookings-view/components/ExportButton.tsx" data-component-line="77" data-component-end-line="77" data-component-file="ExportButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22sm%3Ahidden%22%2C%22textContent%22%3A%22Export%22%7D" className="sm:hidden">Export</span>
    </button>
  );
};

export default ExportButton;
